



































import _ from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import * as ApiPath from '@/tcw/constant/ApiPath'
import KintaiGetsudoDataView from '@/components/kintai/organisms/KintaiGetsudoDataView.vue'
import KintaiCardList from '@/components/kintai/organisms/KintaiCardList.vue'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import Getsudo from '@/tcw/domain/Getsudo'
import { ApiGeneralPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import { TCWApiError, TCWBaseError } from '@/plugins/TCWBaseError'
import { ERR_CODE_WEB_API_NOT_FOUND } from '@/tcw/constant/ErrorCode'
import { KintaiActionMenu } from '../../kintai/types'
import ShouninKintaiLocalHeader from '../molecules/ShouninKintaiLocalHeader.vue'

@Component({
  components: {
    TcwLayoutBasicTemplate,
    KintaiGetsudoDataView,
    KintaiCardList,
    ShouninKintaiLocalHeader
  }
})
export default class ShouninKintaiListPage extends Mixins(BasePage, DataGetComponent) {
  private initDialogVisible = false
  private isInited = true
  private isCreating = false
  private isDownloading = false

  private user: ApiGeneralSinglePayload | null = null
  private shouninInfo: ApiGeneralPayload | null = null
  private teishutsu: ApiGeneralSinglePayload | null = null

  get targetGetsudo(): Getsudo {
    if (this.routeParams.year && this.routeParams.month) {
      // URLパラメータに月度が指定されていた場合(承認対象者の提出情報を確認する場合)
      return Getsudo.of(this.routeParams.year, this.routeParams.month)
    } else {
      // 月度未指定の場合
      return this.currentGetsudo
    }
  }
  get keyInfo(): { year: number; month: number; userId: number | string } {
    return {
      year: this.targetGetsudo.yearValue,
      month: this.targetGetsudo.monthValue,
      userId: this.routeParams.teishutsushaId
    }
  }
  get apiPath(): string {
    console.log(`${this.routeParams.teishutsushaId}のユーザー情報を参照`)
    return ApiPath.buildPath(ApiPath.Paths.MUser.get, this.keyInfo)
  }

  get hasShouninTask(): boolean {
    if (this.shouninInfo === null || _.isArray(this.shouninInfo)) {
      return false
    }
    if (!_.isArray(this.shouninInfo.abailableActionList)) {
      return false
    }
    return this.shouninInfo.abailableActionList.length > 0
  }
  get isKanryo(): boolean {
    if (this.isLoading) {
      return false
    }
    return this.teishutsu?.status === '3'
  }

  protected async beforeProc(): Promise<void> {
    this.isInited = false
    this.teishutsu = null
    this.shouninInfo = [] // 承認タスクをクリア

    // 自分自身の勤怠一覧からくる場合もあるので勤怠チェックモードは一旦解除
    this.$tcw.$store.basic.setKintaiCheckMode(false)
  }

  protected async afterProc(): Promise<void> {
    await this.fetchTeishutsuInfo()
    // // 承認タスクを確認
    await this.fetchShouninTask()

    return Promise.resolve()
  }

  protected responseInitWebApi(response: ApiGeneralSinglePayload): void {
    this.user = response.payload as ApiGeneralSinglePayload
  }

  protected async errorProc(e: unknown): Promise<void> {
    if (e instanceof TCWApiError) {
      const errorCode = e.getErrorCode()
      if (errorCode === ERR_CODE_WEB_API_NOT_FOUND) {
        // 未初期化ならダイアログを表示
        this.initDialogVisible = true
        return
      }
    }

    if (e instanceof TCWBaseError) {
      await this.defaultErrorProc(e)
    }
  }
  
  /**
   * 提出情報をサーバから取得する
   */
  private async fetchTeishutsuInfo() {
    // APIリクエスト情報を作成
    const keyInfo = {
      year: this.targetGetsudo.yearValue,
      month: this.targetGetsudo.monthValue,
      userId: this.routeParams.teishutsushaId
    }
    const path = ApiPath.buildPath(ApiPath.Paths.TeishutsuOther.get, keyInfo)

    console.log('指定された月度の提出情報取得', keyInfo)

    // APIを実行する
    try {
      const response: ApiGeneralSinglePayload = await this.getWebApi().call<ApiGeneralSinglePayload>(
        path,
        'GET'
      )
      this.teishutsu = response
    } catch (e) {
      if (e instanceof TCWApiError && e.getStatusCode() === 404) {
        console.log('提出情報ありません')
      } else {
        throw e
      }
    }
  }

  /**
   * 承認情報をサーバから取得する
   */
  private async fetchShouninTask() {
    // APIリクエスト情報を作成
    const keyInfo = {
      year: this.targetGetsudo.yearValue,
      month: this.targetGetsudo.monthValue,
      userId: this.routeParams.teishutsushaId
    }
    const path = ApiPath.buildPath(ApiPath.Paths.ShouninInput.get, keyInfo)

    console.log('指定された月度の承認タスクの取得', keyInfo)

    // APIを実行する
    try {
      const response: ApiGeneralPayload = await this.getWebApi().call<ApiGeneralPayload>(
        path,
        'GET'
      )
      this.shouninInfo = response
    } catch (e) {
      if (e instanceof TCWApiError && e.getStatusCode() === 404) {
        console.log('現在承認タスクはありません')
      } else {
        throw e
      }
    }
  }

  /**
   * アクション
   */
  get abailableActions(): KintaiActionMenu[] {
    const actions: KintaiActionMenu[] = []

    // 承認フロー
    if (this.hasShouninTask) {
      // 承認タスクがあるかどうか
      actions.push({
        id: 1,
        category: 'flow',
        label: '承認フロー',
        command: 'execShounin',
        icon: 'approval'
      })
    }

    // 承認フロー完了解除
    if (this.isKanryo) {
      actions.push({
        id: 3,
        category: 'flow',
        label: '完了解除',
        command: 'execKanryoKaijo',
        icon: 'approval'
      })
    }

    actions.push({
      id: 2,
      category: 'output',
      label: 'Excel出力',
      command: 'exportExcel',
      icon: 'file_download'
    })
    actions.push({
      id: 4,
      category: 'output',
      label: '遅延証明書出力',
      command: 'exprotChienShoumei',
      icon: 'file_download'
    })
    return actions
  }
  private async execAction(command: string) {
    switch (command) {
      case 'execShounin':
        this.$router.push(
          `/shounin/${this.keyInfo.year}/${this.keyInfo.month}/${this.keyInfo.userId}`
        )
        break
      case 'execKanryoKaijo':
        this.breakKanryo()
        break
      case 'exportExcel':
        this.exportCsvGetsudo()
        break
      case 'exprotChienShoumei':
        this.exprotChienShoumei()
        break
      default:
        console.log(`未対応のコマンド: ${command}`)
        break
    }
  }
  protected async breakKanryo(): Promise<void> {
    const confirm = await this.$tcw.confirm({
      type: 'error',
      title: '完了済みのフローを解除しますか？',
      message: `完了後に修正が必要な場合のみ解除してください。`
    })
    if (!confirm) {
      return
    }
    try {
      this.isLoading = true
      const path = ApiPath.buildPath(ApiPath.Paths.KanryoKaijo.post, {
        year: this.targetGetsudo.yearValue,
        month: this.targetGetsudo.monthValue,
        userId: this.routeParams.teishutsushaId
      })
      await this.getWebApi().call<ApiGeneralSinglePayload>(path, 'GET')
      this.$tcw.message({
        type: 'success',
        title: '完了済みフローを解除しました',
        message:
          '承認フローアクションから提出者まで差戻・取下をすると修正ができます。修正後は再度フローを実行して完了してください。'
      })
      this.init()
    } catch (e) {
      let message = '予期せぬエラー'
      if (e instanceof TCWApiError) {
        message = e.outputMessage()
      }
      this.$tcw.message({
        type: 'error',
        title: '完了済みフローの解除に失敗しました。',
        message
      })
    } finally {
      this.isLoading = false
    }
  }
  protected async exportCsvGetsudo(): Promise<void> {
    try {
      this.isDownloading = true
      const path = ApiPath.buildPath(ApiPath.Paths.Export.other, {
        userId: this.routeParams.teishutsushaId,
        year: this.targetGetsudo.yearValue,
        month: this.targetGetsudo.monthValue
      })
      const response = await this.getWebApi().callRaw<string>(
        path,
        'POST',
        {},
        { responseType: 'blob' }
      )

      let fileName = this.tcw.getDecodedFileNameFromHeader(response.headers)
      if (fileName === null) {
        fileName = 'TCard_Excel.zip'
      }
      this.tcw.execDownloadFile(fileName, response.data)
    } catch (e) {
      let message = '予期せぬエラー'
      if (e instanceof TCWApiError) {
        message = `[${e.getErrorCode()}]${e.outputMessage()}`
      }
      this.$tcw.message({
        type: 'error',
        title: 'Exceファイルの取得に失敗しました',
        message
      })
    } finally {
      this.isDownloading = false
    }
  }
  protected async exprotChienShoumei(): Promise<void> {
    try {
      this.isDownloading = true
      const path = ApiPath.buildPath(ApiPath.Paths.ExportChienShoumei.otherGetsudo, {
        userId: this.routeParams.teishutsushaId,
        year: this.targetGetsudo.yearValue,
        month: this.targetGetsudo.monthValue
      })
      const response = await this.getWebApi().callRaw<string>(
        path,
        'GET',
        {},
        { responseType: 'blob' }
      )

      let fileName = this.tcw.getDecodedFileNameFromHeader(response.headers)
      if (fileName === null) {
        fileName = '遅延証明書.zip'
      }
      this.tcw.execDownloadFile(fileName, response.data)
    } catch (e) {
      let title = '遅延証明書の取得に失敗しました'
      let message = ''
      if (e instanceof TCWApiError) {
        if (e.getStatusCode() === 404) {
          title = '遅延証明書は登録されていません'
        } else {
          message = `[${e.getErrorCode()}]${e.outputMessage()}`
        }
      } else {
        message = '予期せぬエラー'
      }
      this.$tcw.message({ type: 'error', title, message })
    } finally {
      this.isDownloading = false
    }
  }
  private get teishutsushaName(): string {
    return this.teishutsu?.teishutsusha &&
      typeof this.teishutsu?.teishutsusha === 'object' &&
      !_.isArray(this.teishutsu?.teishutsusha) &&
      typeof this.teishutsu?.teishutsusha?.userName === 'string'
      ? this.teishutsu?.teishutsusha?.userName
      : ''
  }
}
